import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { UserResponsibilityCountTableModel, UserResponsibilityCountViewModel } from "./ReviewUserResponsibility.type";
import { IReviewUserResponsibilityProps } from "./ReviewUserResponsibility";
import { useTranslation } from "../../localization/useTranslation";
import { useState } from "react";
import { UserResponsibilityEntityType } from "./ReviewUserResponsibility.type";

export default function useUserReviewResponsibility(props: IReviewUserResponsibilityProps) {
    const { translateUserResponsibilityEntityType } = useTranslation();
    const { isLoading, data, refetch } = useDotLegalQuery<Array<UserResponsibilityCountViewModel>>(`/users/${props.userId}/responsibilityCounts`);
    const [selectedEntityType, setSelectedEntityType] = useState<UserResponsibilityEntityType | undefined>(undefined);
    function convertToTableModel(responsibilityCounts: Array<UserResponsibilityCountViewModel>): Array<UserResponsibilityCountTableModel> {
        return responsibilityCounts.map((row) => {
            return {
                ...row,
                entityName: translateUserResponsibilityEntityType(row.entityType),
            };
        });
    }

    return {
        isLoading,
        refetch,
        tableData: convertToTableModel(data ?? []),
        selectedEntityType,
        setSelectedEntityType,
    };
}
